import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material';

import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';

import { BaseListPage } from 'src/app/core/services/base-list-page';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';
import { NotificationService } from './notifications.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
	selector: 'prgov-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent extends BaseListPage implements OnInit {
	constructor(
		public dialog: MatDialog,
		public translate: TranslateService,
		public notificationService: NotificationService,
		public multiLanguageService: MultiLanguageService,
		private router: Router,
		private authService: AuthService
	) {
		super();
	}

	ngOnInit() {
		this.notificationService.notificationRefresh.subscribe(() => {
			this.load();
		});
	}

	load() {
		if (this.isWorking()) { return; }

		this.startWorking('loading');

		this.notificationService.get()
			.then((data: any) => {
				this.stopWorking();
			});
	}

	updateSeen(item) {
		this.notificationService.updateSeen(item);
		// if (this.authService.hasRole('tecnico interno')) {
		// 	this.router.navigate([`/transactions-admin/`, item.EntityId]);
		// } else {
		// 	this.router.navigate([item.UriPathTemplate.replace('{0}', item.EntityId)]);
		// }
		this.notificationService.showNotifications = false;
	}

	toggleNotifications() {
		this.notificationService.showNotifications = false;
	}

	tryDelete(workingItem) {
		if (this.isWorking()) { return; }

		this.translate.get(['inbox.tryDelete', 'inbox.deleted',
			'message.yes', 'message.no'])
			.subscribe(translations => {
				this.workingItem = workingItem;

				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['inbox.tryDelete'],
						yesText: translations['message.yes'],
						noText: translations['message.no']
					}
				});

				dialogRef.afterClosed().subscribe(result => {
					if (result === 1) {
						this.delete(translations['inbox.deleted']);
					}
				});
			});
	}

	delete(msg) {
		if (this.isWorking()) { return; }

		this.startWorking('delete');

		this.notificationService
			.deleteMessage(this.workingItem.Id)
			.then((result: any) => {
				this.stopWorking();

				this.notificationService.getCount();

				if (result.Success === true) {
					this.load();
				}
			});
	}
}
